import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full py-20 px-6 bg-cream-dark" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <FadeIn data-id="element-177">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border-2 border-sage-light text-center relative overflow-hidden" data-id="element-178">
            {/* Decorative background shield */}
            <ShieldCheck className="absolute -right-10 -bottom-10 w-64 h-64 text-sage-light/10" data-id="element-179" />

            <div className="relative z-10" data-id="element-180">
              <div className="mx-auto w-20 h-20 bg-sage-light/20 text-sage-dark rounded-full flex items-center justify-center mb-6" data-id="element-181">
                <ShieldCheck className="w-10 h-10" data-id="element-182" />
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6 font-serif" data-id="element-183">
                💯 Garantía de 30 Días Sin Preguntas
              </h2>

              <p className="text-lg md:text-xl text-charcoal-light leading-relaxed mb-6" data-id="element-184">
                Si aplicas el método durante 7 días y no ves ningún cambio en
                las transiciones con tu hijo, te devolvemos el 100% de tu
                dinero. Sin formularios. Sin drama. Sin preguntas.
              </p>

              <p className="text-sage-dark font-bold text-lg" data-id="element-185">
                Así de seguros estamos de lo que este método puede hacer por tu
                familia.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}